import * as React from "react";
import { Query, QueryResult } from "react-apollo";
import {
  GetMailingListQuery,
  GetMailingListQueryVariables
} from "../../__generated__/types";
import { MAILING_LIST_QUERY } from "./queries";

export class MailingListQuery extends Query<
  GetMailingListQuery,
  GetMailingListQueryVariables
> {}

interface Props {
  id: string;
  children(props: QueryResult<GetMailingListQuery>): React.ReactNode;
}

export default ({ id, children }: Props) => {
  return (
    <MailingListQuery query={MAILING_LIST_QUERY} variables={{ id }}>
      {result => children(result)}
    </MailingListQuery>
  );
};



// WEBPACK FOOTER //
// ./src/queries/MailingListQuery/MailingListQuery.tsx